import { useEffect, useState } from 'react'
import OrderCard from '../components/OrderCard'

const API = process.env.REACT_APP_API_URL

function OrdersDashboard() {
  const [orders, setOrders] = useState([])
  const [statusFilter, setStatusFilter] = useState('')

  useEffect(() => {
    const fetchOrders = async () => {
      const url = statusFilter
        ? `${API}/orders?status=${statusFilter}`
        : `${API}/orders`

      const res = await fetch(url)
      const data = await res.json()
      setOrders(data)
    }

    fetchOrders()
  }, [statusFilter])

  const updateStatus = async (id, status) => {
    await fetch(`${API}/orders/${id}/status`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    })

    setOrders(orders =>
      orders.map(order =>
        order._id === id ? { ...order, status } : order
      )
    )
  }

  return (
    <div>
      <h2>Orders Dashboard</h2>

      <select
        value={statusFilter}
        onChange={e => setStatusFilter(e.target.value)}
      >
        <option value="">All</option>
        <option>Pending</option>
        <option>Preparing</option>
        <option>Ready</option>
        <option>Delivered</option>
        <option>Cancelled</option>
      </select>

      {orders.map(order => (
        <OrderCard
          key={order._id}
          order={order}
          onStatusChange={updateStatus}
        />
      ))}
    </div>
  )
}

export default OrdersDashboard
